// extracted by mini-css-extract-plugin
module.exports = {"radio_group":"PaymentPeriodRadio_radio_group__V5Kk1","discount_chip":"PaymentPeriodRadio_discount_chip__gnULV"};